import {
  Button,
  Checkbox,
  CircularProgress,
  Collapse,
  Divider,
  IconButton,
  InputAdornment,
  List,
  ListItemButton,
  ListItemText,
  ListSubheader,
  TableCell,
  TableRow,
  TextField,
  styled,
  tableCellClasses,
} from "@mui/material";
import { useRef } from "react";
import React, { useState } from "react";
import { Box, FormControlLabel, Grid, Typography } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import SearchIcon from "@mui/icons-material/Search";

import CancelIcon from "@mui/icons-material/Cancel";

import {
  useGetDmsCategoriesMutation,
  useGetDmsManufacturersQuery,
} from "../../../redux/reducer/features/ShoppingPortal/ShoppingPortalSlice";
import { useSelector } from "react-redux";
import { AppState } from "../../../redux/reducer/rootReducer";
import {
  DmsCategory,
  DmsManufacturer,
} from "../../../models/features/ShoppingPortal/DmsManufacturer";

import { DmsLocations } from "../../../models/auth/Auth";
import { capitalizeFirstLetter } from "../../../services/utilities/utility";

interface PartsListFilterProps {
  setPaging: any;
  isLoading: boolean;
  selectedManufacturers: string[];
  setSelectedManufacturers: any;
  selectedLocations: DmsLocations[];
  setSelectedLocations: any;
  search: any;
  setSearch: any;
  selectedCategories: string[];
  setSelectedCategories: any;
}

export const PartsListFilter: React.FunctionComponent<PartsListFilterProps> = ({
  setPaging,
  isLoading,
  selectedManufacturers,
  setSelectedManufacturers,
  selectedLocations,
  setSelectedLocations,
  search,
  setSearch,
  selectedCategories,
  setSelectedCategories,
}) => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  let mfrCode = urlSearchParams.get("mfrCode");
  let categoryId = urlSearchParams.get("categoryId");
  const [locationOpen, setLocationOpen] = React.useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchCategoryText, setSearchCategoryText] = useState("");
  const [dmsManufacturers, setDmsManufacturers] = useState<DmsManufacturer[]>(
    []
  );
  const [dmsCategories, setDmsCategories] = useState<DmsCategory[]>([]);
  const [filteredCategories, setFilteredCategories] = useState<DmsCategory[]>(
    []
  );

  const [filteredManufacturers, setFilteredManufacturers] = useState<
    DmsManufacturer[]
  >([]);
  const dmsDealerId = useSelector(
    (state: AppState) => state.shoppingPortalReducer.portalSettings?.dmsDealerId
  );
  const [manufacturerOpen, setManufacturerOpen] = React.useState(false);
  const [categoryOpen, setCategoryOpen] = React.useState(false);
  const [dmsCategoriesMutation, dmsCategoriesMutationResult] =
    useGetDmsCategoriesMutation();

  const dmsLocations = useSelector(
    (state: AppState) =>
      state.shoppingPortalReducer.portalSettings?.dmsLocations
  );
  const { data: dmsManufacturersList } = useGetDmsManufacturersQuery({
    dealerId: dmsLocations ? dmsLocations[0].dealerId.toString() ?? "" : "",
  });

  const hideMfgs = useSelector(
    (state: AppState) =>
      state.shoppingPortalReducer.portalSettings?.setting?.hideMfgs
  );
  const handleClearFilter = () => {
    setSearch("");
    setSelectedLocations([]);
    if (mfrCode === null) setSelectedManufacturers([]);
    setSelectedCategories([]);
  };

  const handleSearch = () => {
    setPaging((paging: any) => ({ ...paging, pageIndex: 0 }));
  };

  const handleManufacturerClick = () => {
    setManufacturerOpen(!manufacturerOpen);
  };

  const handleSearchManufacturers = (e: any) => {
    const inputValue = e.target.value;
    setSearchText(inputValue);
    const filtered = dmsManufacturers.filter(
      (mfg) =>
        mfg.name.toLowerCase().includes(inputValue.toLowerCase()) ||
        mfg.code.toLowerCase().includes(inputValue.toLowerCase())
    );

    setFilteredManufacturers(filtered);
  };

  const handleSearchCategories = (e: any) => {
    const inputValue = e.target.value;
    setSearchCategoryText(inputValue);
    const filtered = dmsCategories.filter(
      (mfg) =>
        mfg.description.toLowerCase().includes(inputValue.toLowerCase()) ||
        mfg.categoryId.toLowerCase().includes(inputValue.toLowerCase())
    );

    setFilteredCategories(filtered);
  };

  const handleClick = () => {
    setLocationOpen(!locationOpen);
  };

  // const handleGetDmsManufacturers = () => {
  //   dmsManufacturersMutation({
  //     dealerId: dmsLocations ? dmsLocations[0].dealerId?.toString() : "",
  //   }).then((response: any) => {
  //     if (response.data && response.data.status === 200) {
  //       let data = response.data.entityList.filter(
  //         (mfg: any) => !hideMfgs?.some((item: string) => item === mfg.code)
  //       );
  //       setDmsManufacturers(data);
  //       setFilteredManufacturers(data);
  //     }
  //   });
  // };
  React.useEffect(() => {
    if (
      dmsManufacturersList?.entityList &&
      dmsManufacturersList.entityList?.length > 0
    ) {
      setFilteredManufacturers(dmsManufacturersList.entityList);
      setDmsManufacturers(dmsManufacturersList.entityList);
      setFilteredManufacturers(dmsManufacturersList.entityList);
    }
  }, [dmsManufacturersList]);
  const handleGetDmsCategories = () => {
    dmsCategoriesMutation({
      dealerIds: dmsLocations
        ? dmsLocations.map((n) => n.dealerId.toString())
        : [],
    }).then((response: any) => {
      if (response.data && response.data.status === 200) {
        let data = response.data.entityList.filter((cat: any) => cat.isActive);
        setDmsCategories(data);
        setFilteredCategories(data);
      }
    });
  };

  React.useEffect(() => {
    if (dmsLocations !== undefined && dmsDealerId !== undefined) {
      handleGetDmsCategories();
    }
  }, [dmsDealerId]);

  return (
    <>
      <>
        <List
          sx={{
            width: "100%",
            maxWidth: 360,
            bgcolor: "background.paper",
          }}
          component="nav"
          aria-labelledby="nested-list-subheader"
          subheader={
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <ListSubheader component="div" id="nested-list-subheader">
                Filter:
              </ListSubheader>
              <div>
                <Button
                  id="basic-button"
                  sx={{ fontSize: "0.7125rem" }}
                  size="small"
                  variant="contained"
                  aria-controls={locationOpen ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  disabled={
                    search !== "" ||
                    selectedLocations.length > 0 ||
                    selectedCategories.length > 0 ||
                    selectedManufacturers.length > 0
                      ? false
                      : true
                  }
                  color="warning"
                  onClick={handleClearFilter}
                  endIcon={<CancelIcon fontSize="small" />}
                >
                  Clear
                </Button>
              </div>
            </Box>
          }
        >
          <Divider />
          <Box mt={1} mb={1}>
            <TextField
              id="search"
              name="search"
              fullWidth
              placeholder="Search.."
              variant="outlined"
              size="small"
              onKeyUp={(e: any) => {
                if (e.key === "Enter") {
                  handleSearch();
                } else if (e.key === "Backspace" && search === "") {
                  setPaging((paging: any) => ({ ...paging, pageIndex: 0 }));
                }
              }}
              onChange={(e: any) => {
                setSearch(e.target.value);
              }}
              value={search}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {isLoading ? (
                      <CircularProgress size="1.2rem" color="inherit" />
                    ) : (
                      <IconButton
                        onClick={() => {
                          handleSearch();
                        }}
                      >
                        <SearchIcon
                          sx={{ fontSize: "20px", cursor: "pointer" }}
                        />
                      </IconButton>
                    )}
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          <Divider />
          <ListItemButton onClick={handleClick}>
            <ListItemText primary="Locations" />
            {locationOpen ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={locationOpen} timeout="auto" unmountOnExit>
            <List
              component="div"
              disablePadding
              sx={{ maxHeight: "22vh", overflowY: "auto" }}
            >
              {dmsLocations && dmsLocations.length > 0
                ? dmsLocations.map((loc) => {
                    return (
                      <ListItemButton key={loc.id} sx={{ pl: 4 }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedLocations.some(
                                (i: DmsLocations) => i.id == loc.id
                              )}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedLocations([
                                    ...selectedLocations,
                                    loc,
                                  ]);
                                } else {
                                  setSelectedLocations(
                                    selectedLocations.filter(
                                      (item: DmsLocations) => item.id !== loc.id
                                    )
                                  );
                                }
                              }}
                              name={loc.name}
                            />
                          }
                          label={capitalizeFirstLetter(loc.name)}
                        />
                      </ListItemButton>
                    );
                  })
                : ""}{" "}
            </List>
          </Collapse>
          {mfrCode === null && (
            <>
              <Divider />
              <ListItemButton onClick={handleManufacturerClick}>
                <ListItemText primary="Manufacturers" />
                {manufacturerOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={manufacturerOpen} timeout="auto" unmountOnExit>
                <TextField
                  fullWidth
                  id="searchMfg"
                  name="searchMfg"
                  placeholder="Search Manufacturers"
                  variant="outlined"
                  size="small"
                  onChange={(e: any) => {
                    handleSearchManufacturers(e);
                  }}
                  value={searchText}
                />
                <List
                  component="div"
                  disablePadding
                  sx={{ maxHeight: "23vh", overflowY: "auto" }}
                >
                  {filteredManufacturers.map((mfg) => {
                    return (
                      <ListItemButton key={mfg.manufacturerId} sx={{ pl: 4 }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedManufacturers.some(
                                (i) => i == mfg.code
                              )}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedManufacturers([
                                    ...selectedManufacturers,
                                    mfg.code,
                                  ]);
                                } else {
                                  setSelectedManufacturers(
                                    selectedManufacturers.filter(
                                      (item) => item !== mfg.code
                                    )
                                  );
                                }
                              }}
                              name={mfg.name}
                            />
                          }
                          label={capitalizeFirstLetter(mfg.name)}
                        />
                      </ListItemButton>
                    );
                  })}
                </List>
              </Collapse>
            </>
          )}

          {categoryId === null && (
            <>
              <Divider />
              <ListItemButton onClick={() => setCategoryOpen(!categoryOpen)}>
                <ListItemText primary="Categories" />
                {categoryOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={categoryOpen} timeout="auto" unmountOnExit>
                <TextField
                  fullWidth
                  id="searchCat"
                  name="searchCat"
                  placeholder="Search Categoires"
                  variant="outlined"
                  size="small"
                  onChange={(e: any) => {
                    handleSearchCategories(e);
                  }}
                  value={searchCategoryText}
                />
                <List
                  component="div"
                  disablePadding
                  sx={{ maxHeight: "23vh", overflowY: "auto" }}
                >
                  {filteredCategories.map((cat) => {
                    return (
                      <ListItemButton key={cat.categoryId} sx={{ pl: 4 }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedCategories.some(
                                (i: string) => i == cat.categoryId
                              )}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedCategories([
                                    ...selectedCategories,
                                    cat.categoryId,
                                  ]);
                                } else {
                                  setSelectedCategories(
                                    selectedCategories.filter(
                                      (item: string) => item !== cat.categoryId
                                    )
                                  );
                                }
                              }}
                              name={cat.categoryId}
                            />
                          }
                          label={capitalizeFirstLetter(cat.description)}
                        />
                      </ListItemButton>
                    );
                  })}
                </List>
              </Collapse>
            </>
          )}
          <Divider />
        </List>
      </>
    </>
  );
};

export const searchOptions = {
  types: ["address"],
};
